/**
 * Ringkasan total order di sidebar checkout (gaya Shopify).
 *
 * Kenapa perlu JS padahal layout-nya CSS: di halaman checkout, WooCommerce
 * core sengaja TIDAK merender cart totals — woocommerce_cart_totals() diawali
 * `if (is_checkout()) return;` (lihat
 * plugins/woocommerce/includes/wc-template-functions.php). Jadi
 * <div class="cart-collaterals"> yang ikut keluar dari shortcode
 * [woocommerce_cart] selalu kosong di /checkout/, dan Subtotal/Ongkir/Total
 * mustahil ditampilkan di sidebar lewat CSS saja.
 *
 * Satu-satunya sumber angka yang hidup di halaman ini adalah tabel
 * #order_review (di-refresh WooCommerce lewat AJAX update_order_review tiap
 * alamat/ongkir/kupon berubah). Modul ini MEMBACA tabel itu lalu menuliskan
 * ulang angkanya sebagai ringkasan di sidebar — tanpa memindahkan satu node
 * pun, supaya wizard multistep (jQuery Steps milik plugin WooCommerce
 * Multistep Checkout), validasi step, dan submit checkout tetap utuh.
 *
 * Nilai diambil sebagai TEKS, bukan clone HTML: baris ongkir di #order_review
 * ikut membawa <form class="woocommerce-shipping-calculator"> lengkap dengan
 * id (#calc_shipping_country dsb), jadi meng-clone-nya akan menduplikasi id
 * di dalam dokumen.
 */

var MOUNT_SELECTOR = ".cart-collaterals";
var REVIEW_TABLE_SELECTOR = "#order_review .woocommerce-checkout-review-order-table";
var COUPON_SELECTOR = ".woocommerce-cart-form .coupon";
var ROOT_CLASS = "dufeng-checkout-summary";
var COUPON_MODAL_ID = "dufeng-coupon-modal";

// ---- Ringkasan sticky mobile/tablet ----
var MSUMMARY_CLASS = "dufeng-checkout-msummary";
var MSUMMARY_OPEN_CLASS = "dufeng-msummary-open";
var MSUMMARY_MEDIA = "(max-width: 991px)";
var MSUMMARY_LABEL = "Ringkasan";
var MSUMMARY_STATE_KEY = "dufeng_checkout_msummary_open";
var CART_PANEL_SELECTOR = ".woocommerce:has(.woocommerce-cart-form)";

// Baris ongkir sebelum alamat diisi berbunyi panjang ("Enter your address to
// view shipping options.") dan merusak layout dua kolom label/nilai. Kalau
// belum ada angka atau pilihan ongkir, pakai teks pendek ini.
var SHIPPING_PENDING_TEXT = "Dihitung di langkah berikutnya";
var LONG_VALUE_CHARS = 40;

function textOf(node) {
  return node ? (node.textContent || "").replace(/\s+/g, " ").trim() : "";
}

/**
 * Ambil nilai satu baris total sebagai teks bersih.
 * Prioritas: opsi ongkir yang dipilih -> angka harga -> teks apa adanya.
 */
function extractValue(td) {
  var clone = td.cloneNode(true);

  // Buang kalkulator ongkir & teks screen-reader supaya tidak ikut terbaca
  // sebagai "nilai" baris.
  var noise = clone.querySelectorAll(
    "form, .shipping-calculator-button, .shipping-calculator-form, .screen-reader-text"
  );
  for (var i = 0; i < noise.length; i++) {
    noise[i].parentNode.removeChild(noise[i]);
  }

  // Kalau user sudah memilih metode ongkir, label metode itu yang paling
  // informatif (umumnya sudah memuat nama kurir sekaligus harganya).
  var checked = clone.querySelector('input[name^="shipping_method"]:checked');
  if (checked && checked.parentNode) {
    var label = checked.parentNode.querySelector("label");
    if (label) return textOf(label);
  }

  var price = clone.querySelector(".woocommerce-Price-amount");
  if (price) return textOf(price);

  var raw = textOf(clone);
  if (!raw) return "";

  // Sisa teks panjang = status "belum bisa dihitung", bukan angka.
  return raw.length > LONG_VALUE_CHARS ? SHIPPING_PENDING_TEXT : raw;
}

function buildRow(label, value, isTotal) {
  var row = document.createElement("div");
  row.className = ROOT_CLASS + "__row" + (isTotal ? " " + ROOT_CLASS + "__row--total" : "");

  var labelEl = document.createElement("span");
  labelEl.className = ROOT_CLASS + "__label";
  labelEl.textContent = label;

  var valueEl = document.createElement("span");
  valueEl.className = ROOT_CLASS + "__value";
  valueEl.textContent = value;

  row.appendChild(labelEl);
  row.appendChild(valueEl);
  return row;
}

function renderTotals(mount) {
  var table = document.querySelector(REVIEW_TABLE_SELECTOR);
  if (!table) return;

  var rows = table.querySelectorAll("tfoot tr");
  if (!rows.length) return;

  var box = document.createElement("div");
  box.className = ROOT_CLASS;

  for (var i = 0; i < rows.length; i++) {
    var th = rows[i].querySelector("th");
    var td = rows[i].querySelector("td");
    if (!th || !td) continue;

    var label = textOf(th);
    var value = extractValue(td);
    if (!label || !value) continue;

    box.appendChild(buildRow(label, value, rows[i].classList.contains("order-total")));
  }

  var existing = mount.querySelector("." + ROOT_CLASS);
  if (existing) mount.removeChild(existing);
  mount.appendChild(box);
}

/**
 * Tombol kupon di sidebar ringkasan.
 *
 * Form kupon inline bawaan [woocommerce_cart] tidak dipakai lagi — node-nya
 * tetap di tempat (disembunyikan CSS) supaya AJAX update cart WooCommerce
 * tidak terganggu, dan tombol ini dialihkan membuka popup kupon
 * (includes/woocommerce/checkout-coupons.php + modules/checkout-coupon.js).
 *
 * Tombolnya cuma diberi dua atribut, tanpa teks & tanpa listener sendiri:
 * - data-dufeng-coupon-open → klik ditangani listener terdelegasi milik modul
 *   popup, jadi tombol yang dipasang ulang setelah cart dirender ulang tetap
 *   berfungsi tanpa bind ulang.
 * - data-dufeng-coupon-sync  → teksnya diisi modul popup dengan menyalin label
 *   bar di atas tabel review order ("Apply coupon" / "Coupon: KODE"), supaya
 *   kedua pemicu selalu berbunyi sama dan status kupon tidak dihitung dua kali.
 */
function initCouponToggle() {
  var coupon = document.querySelector(COUPON_SELECTOR);
  if (!coupon || coupon.getAttribute("data-dufeng-toggle")) return;

  // Popup-nya cuma ada kalau kupon aktif & keranjang terisi. Kalau tidak ada,
  // biarkan form inline bawaan WooCommerce apa adanya daripada memasang tombol
  // yang tidak membuka apa-apa.
  if (!document.getElementById(COUPON_MODAL_ID)) return;

  coupon.setAttribute("data-dufeng-toggle", "1");

  var toggle = document.createElement("button");
  toggle.type = "button";
  toggle.className = ROOT_CLASS + "__coupon-toggle";
  toggle.setAttribute("data-dufeng-coupon-open", "");
  toggle.setAttribute("data-dufeng-coupon-sync", "");

  coupon.parentNode.insertBefore(toggle, coupon);
}

/**
 * Ringkasan pesanan versi mobile/tablet.
 *
 * Di layar sempit kolom ringkasan (output [woocommerce_cart]) menumpuk di atas
 * form dan memakan hampir satu layar penuh sebelum user sampai ke isian
 * checkout. Di bawah 992px kolom itu dijadikan panel sticky yang tertutup
 * (CSS-nya di src/scss/section/_checkout.scss), dan modul ini yang menyuntik
 * pemicunya: bar bawah layar berisi jumlah item + total, mirip tombol sticky
 * "Add to cart" di halaman produk.
 *
 * Yang disuntik cuma bar + backdrop sebagai elemen BARU di <body>; isi
 * keranjangnya sendiri tidak dipindah sama sekali, jadi AJAX update cart,
 * kupon, dan wizard multistep tetap utuh.
 */
function getCartCount() {
  var inputs = document.querySelectorAll(".woocommerce-cart-form input.qty");
  var total = 0;
  var counted = 0;

  for (var i = 0; i < inputs.length; i++) {
    var value = parseInt(inputs[i].value, 10);
    if (!isNaN(value)) {
      total += value;
      counted++;
    }
  }

  // Produk "sold individually" dirender sebagai teks, bukan input qty, jadi
  // barisnya tidak ikut terhitung di atas — dihitung per baris di sini.
  if (!counted) {
    return document.querySelectorAll(".woocommerce-cart-form .cart_item").length;
  }

  return total;
}

function getCartTotal() {
  var table = document.querySelector(REVIEW_TABLE_SELECTOR);
  var row = table && table.querySelector("tfoot tr.order-total td");
  return row ? extractValue(row) : "";
}

function initMobileSummary() {
  var panel = null;
  try {
    panel = document.querySelector(CART_PANEL_SELECTOR);
  } catch (e) {
    // Browser tanpa dukungan :has() melempar SyntaxError di sini. Layout
    // checkout-nya pun sudah bergantung pada :has(), jadi cukup lewati fitur
    // ini — yang penting jangan sampai melempar dan menghentikan modul lain
    // yang di-init setelahnya di main.js.
    return null;
  }

  if (!panel || document.querySelector("." + MSUMMARY_CLASS)) return null;

  var bar = document.createElement("div");
  bar.className = MSUMMARY_CLASS;

  var button = document.createElement("button");
  button.type = "button";
  button.className = MSUMMARY_CLASS + "__btn";
  button.setAttribute("aria-expanded", "false");

  var text = document.createElement("span");
  text.className = MSUMMARY_CLASS + "__text";

  var totalEl = document.createElement("span");
  totalEl.className = MSUMMARY_CLASS + "__total";

  button.appendChild(text);
  button.appendChild(totalEl);
  bar.appendChild(button);

  var backdrop = document.createElement("div");
  backdrop.className = MSUMMARY_CLASS + "__backdrop";

  document.body.appendChild(backdrop);
  document.body.appendChild(bar);

  function setOpen(open) {
    document.body.classList.toggle(MSUMMARY_OPEN_CLASS, open);
    button.setAttribute("aria-expanded", open ? "true" : "false");

    // Ubah qty / pasang kupon dari dalam panel bisa berujung reload halaman;
    // state-nya diingat supaya panel tidak menutup sendiri setelah aksi yang
    // baru saja dilakukan user di dalamnya.
    try {
      window.sessionStorage.setItem(MSUMMARY_STATE_KEY, open ? "1" : "");
    } catch (e) {
      /* storage diblokir (private mode) — tidak apa-apa, cuma tidak diingat */
    }
  }

  function wasOpen() {
    try {
      return "1" === window.sessionStorage.getItem(MSUMMARY_STATE_KEY);
    } catch (e) {
      return false;
    }
  }

  function update() {
    var count = getCartCount();
    text.textContent = MSUMMARY_LABEL + (count ? " (" + count + " item)" : "");
    totalEl.textContent = getCartTotal();

    // Notice error keranjang (stok habis, kupon ditolak, dst) dirender di
    // dalam panel — percuma kalau panelnya tertutup.
    if (panel.querySelector(".woocommerce-error")) setOpen(true);
  }

  button.addEventListener("click", function () {
    setOpen(!document.body.classList.contains(MSUMMARY_OPEN_CLASS));
  });

  backdrop.addEventListener("click", function () {
    setOpen(false);
  });

  document.addEventListener("keydown", function (event) {
    if ("Escape" === event.key) setOpen(false);
  });

  // Panelnya kembali jadi kolom biasa di desktop; state "terbuka" harus ikut
  // dilepas supaya tidak menyisakan body ter-lock saat layar diperbesar.
  var mql = window.matchMedia(MSUMMARY_MEDIA);
  var onChange = function (event) {
    if (!event.matches) setOpen(false);
  };
  if (mql.addEventListener) {
    mql.addEventListener("change", onChange);
  } else if (mql.addListener) {
    mql.addListener(onChange);
  }

  update();
  if (wasOpen() && mql.matches) setOpen(true);

  return update;
}

export function initCheckoutSummary() {
  if (!document.body.classList.contains("woocommerce-checkout")) return;

  var mount = document.querySelector(MOUNT_SELECTOR);
  if (!mount) return;

  function render() {
    renderTotals(mount);
  }

  render();
  initCouponToggle();
  var updateMobileSummary = initMobileSummary();

  // updated_checkout di-trigger WooCommerce lewat jQuery, jadi listener
  // native tidak akan kebagian event-nya.
  var $ = window.jQuery;
  if ($) {
    $(document.body).on("updated_checkout updated_wc_div", function () {
      render();
      // updated_wc_div merender ulang isi keranjang -> tombol toggle ikut
      // hilang dan perlu dipasang lagi.
      initCouponToggle();
      if (updateMobileSummary) updateMobileSummary();
    });
  }
}
